import { Building2, FileText, MapPin, UserRound } from "lucide-react";

const ITEMS = [
  { icon: Building2, text: "Företag, BRF & fastigheter" },
  { icon: MapPin, text: "Lokalt i Södertälje med omnejd" },
  { icon: UserRound, text: "Personlig kontakt med Mats" },
  { icon: FileText, text: "Offert utifrån uppdraget" },
];

export const TrustRow = () => (
  <section className="bg-[var(--paper)] py-5 md:py-6" data-testid="trust-row">
    <ul className="mx-auto grid max-w-[1480px] grid-cols-1 gap-2 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-12 xl:px-16">
      {ITEMS.map(({ icon: Icon, text }) => (
        <li
          key={text}
          className="flex min-h-[64px] items-center gap-3 rounded-2xl border border-[var(--line)] bg-white px-4 py-3 text-[0.94rem] font-medium text-[var(--ink)]"
        >
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[var(--paper)]">
            <Icon size={18} className="text-[var(--red)]" aria-hidden />
          </span>
          {text}
        </li>
      ))}
    </ul>
  </section>
);
